import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import useAuth from "hooks/useAuth"

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const { loggedUser } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (loggedUser && location?.state?.from) {
            navigate(location.state.from, {
                state: {
                    from: "",
                },
                replace: true,
            })
        }
    }, [loggedUser, navigate, location])

    return children
}

export default GuestGuard
